var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { canUseDOM, debugLog, getItemWithExpiry, setItemWithExpiry } from "@lululemon/auth-common";
import { createBroadcastChannel, postMessage } from "./broadcast-utils";
import { REFRESH_TOKEN_INSPECTED_KEY } from "../../utils/constants";
import { getHttpOnlyRefreshTokens, phoenixClient } from "../../graphql";
import { getLogger } from "../../logger";
import { getAuthSdk } from "../../auth-sdk-instance";
import { readAnalyticsAuthState, setAnalyticsAuthState } from "../../utils/analytics-auth-state";
import { removeOIDCCookie, removeRefreshTokenCookie } from "../../cookies";
var broadcastChannel = createBroadcastChannel({ channelName: "lll_auth" });
var logger = getLogger({ app: "login-app" });
var SESSION_REFRESHING_KEY = "lll-isSessionRefreshing";
var TWENTY_SECONDS = 20 * 1000;
var SIX_HOURS = 6 * 60 * 60 * 1000;
/**
 * Retrieve and return the HttpOnly cookies.
 * @param oktaConfig
 */
var fetchHttpOnlyCookies = function (_a) {
    var oktaConfig = _a.oktaConfig;
    return __awaiter(void 0, void 0, void 0, function () {
        var isLoginPage, _b, fullRefreshToken, partialRefreshToken;
        var _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    isLoginPage = (_d = (_c = window === null || window === void 0 ? void 0 : window.location) === null || _c === void 0 ? void 0 : _c.pathname) === null || _d === void 0 ? void 0 : _d.includes("/account/login");
                    if (!isLoginPage &&
                        getItemWithExpiry(REFRESH_TOKEN_INSPECTED_KEY) === "true") {
                        debugLog({
                            message: "[LocalStorage] No HttpOnly cookies found; user is anonymous."
                        });
                        return [2 /*return*/, {}];
                    }
                    return [4 /*yield*/, getHttpOnlyRefreshTokens({
                            oktaConfig: oktaConfig,
                            logger: logger
                        })];
                case 1:
                    _b = _e.sent(), fullRefreshToken = _b.fullRefreshToken, partialRefreshToken = _b.partialRefreshToken;
                    debugLog({
                        message: "Fetched HttpOnly cookies! Full refreshToken: ".concat(fullRefreshToken === null || fullRefreshToken === void 0 ? void 0 : fullRefreshToken.refreshToken, " Partial refreshToken: ").concat(partialRefreshToken === null || partialRefreshToken === void 0 ? void 0 : partialRefreshToken.refreshToken)
                    });
                    // If HttpOnly cookies found, set state; if no HttpOnly cookies found, user is anonymous
                    if (fullRefreshToken || partialRefreshToken) {
                        return [2 /*return*/, { fullRefreshToken: fullRefreshToken, partialRefreshToken: partialRefreshToken }];
                    }
                    debugLog({
                        message: "[GraphQL] No HttpOnly cookies found; user is anonymous."
                    });
                    setItemWithExpiry(REFRESH_TOKEN_INSPECTED_KEY, "true", SIX_HOURS);
                    return [2 /*return*/, {}];
            }
        });
    });
};
/**
 * Handle session refresh.
 * @param authSdk
 * @param httpOnlyCookies
 * @param shapeConfig
 */
var refreshSession = function (_a) {
    var authSdk = _a.authSdk, httpOnlyCookies = _a.httpOnlyCookies, shapeConfig = _a.shapeConfig;
    return __awaiter(void 0, void 0, void 0, function () {
        var isAlreadyRefreshing, onWindowUnload, unloadShape, cleanup, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    isAlreadyRefreshing = getItemWithExpiry(SESSION_REFRESHING_KEY);
                    if (!isAlreadyRefreshing) return [3 /*break*/, 2];
                    debugLog({ message: "Already refreshing, waiting..." });
                    return [4 /*yield*/, waitForRefreshSession()];
                case 1: return [2 /*return*/, _b.sent()];
                case 2:
                    onWindowUnload = function () {
                        unlockSessionRefresh();
                        postMessage({
                            broadcastChannel: broadcastChannel,
                            message: {
                                type: "sessionRefresh",
                                status: "failure"
                            }
                        });
                    };
                    unloadShape = function () { };
                    _b.label = 3;
                case 3:
                    _b.trys.push([3, 6, 7, 8]);
                    lockSessionRefresh();
                    window.addEventListener("beforeunload", onWindowUnload);
                    setAnalyticsAuthState((httpOnlyCookies === null || httpOnlyCookies === void 0 ? void 0 : httpOnlyCookies.fullRefreshToken)
                        ? "authenticated:pending"
                        : "authenticated:partial-login-pending");
                    debugLog({ message: "Loading Shape..." });
                    return [4 /*yield*/, authSdk.prepareShape(__assign({ forceReload: true, shouldUseJSReadyEvent: shapeConfig.shouldUseJSReadyEvent }, shapeConfig))];
                case 4:
                    cleanup = (_b.sent()).cleanup;
                    unloadShape = cleanup;
                    debugLog({ message: "Shape loaded!" });
                    debugLog({ message: "Refreshing session..." });
                    return [4 /*yield*/, authSdk.tryRefreshingSession(__assign({}, httpOnlyCookies))];
                case 5:
                    _b.sent();
                    debugLog({ message: "Session refresh complete!" });
                    postMessage({
                        broadcastChannel: broadcastChannel,
                        message: {
                            type: "sessionRefresh",
                            status: "success"
                        }
                    });
                    return [3 /*break*/, 8];
                case 6:
                    e_1 = _b.sent();
                    debugLog({ message: "Session refresh failed: ".concat(e_1) });
                    logger.error(new Error("Error refreshing session: ".concat(e_1)), {
                        tags: {
                            componentName: "useSessionRefresh",
                            featureName: "useSessionRefresh",
                            functionName: "refreshSession"
                        }
                    });
                    postMessage({
                        broadcastChannel: broadcastChannel,
                        message: {
                            type: "sessionRefresh",
                            status: "failure"
                        }
                    });
                    return [3 /*break*/, 8];
                case 7:
                    if (shapeConfig.unloadShapeAfterSessionRefresh) {
                        debugLog({ message: "Unloading Shape scripts." });
                        unloadShape();
                    }
                    unlockSessionRefresh();
                    window.removeEventListener("beforeunload", onWindowUnload);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    });
};
var lockSessionRefresh = function () {
    debugLog({ message: "Setting localStorage refresh lock." });
    setItemWithExpiry(SESSION_REFRESHING_KEY, "true", TWENTY_SECONDS);
};
var unlockSessionRefresh = function () {
    debugLog({ message: "Removing localStorage refresh lock." });
    localStorage.removeItem(SESSION_REFRESHING_KEY);
};
/**
 * If session is already refreshing, wait for message event when it completes.
 */
var waitForRefreshSession = function (timeoutMs) {
    if (timeoutMs === void 0) { timeoutMs = 30000; }
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            // Wait for a message indicating session refresh has completed
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var onMessage = function (event) {
                        if (event.origin !== window.location.origin)
                            return;
                        if (event.data.type === "sessionRefresh") {
                            debugLog({
                                message: "Received ".concat(event.data.status, " sessionRefresh event.")
                            });
                            // Resolve or reject promise based on event status
                            if (event.data.status === "success") {
                                resolve();
                            }
                            else {
                                reject();
                            }
                            cleanup();
                        }
                    };
                    var cleanup = function () {
                        if (broadcastChannel) {
                            broadcastChannel.removeEventListener("message", onMessage);
                        }
                        else {
                            window.removeEventListener("message", onMessage);
                        }
                        clearTimeout(timeout);
                    };
                    if (broadcastChannel) {
                        broadcastChannel.addEventListener("message", onMessage);
                    }
                    else {
                        window.addEventListener("message", onMessage);
                    }
                    // Add timeout
                    var timeout = setTimeout(function () {
                        reject(new Error("Session refresh timed out after ".concat(timeoutMs, " ms")));
                        cleanup(); // Clean up listeners on timeout
                    }, timeoutMs);
                })];
        });
    });
};
/**
 * Async function to check user auth status and refresh if necessary.
 * @param oktaConfig
 * @param shapeConfig
 */
var checkAndRefreshSession = function (_a) {
    var oktaConfig = _a.oktaConfig, shapeConfig = _a.shapeConfig, _b = _a.onlyCheckLocalToken, onlyCheckLocalToken = _b === void 0 ? false : _b;
    return __awaiter(void 0, void 0, void 0, function () {
        var authSdk, _c, isAuthenticated, refreshToken, _d, fullRefreshToken, partialRefreshToken;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    authSdk = getAuthSdk({ oktaConfig: oktaConfig, env: "beta" });
                    return [4 /*yield*/, Promise.all([
                            authSdk.authClient.getAuthState(),
                            authSdk.authClient.getRefreshToken()
                        ])];
                case 1:
                    _c = __read.apply(void 0, [_e.sent(), 2]), isAuthenticated = _c[0].isAuthenticated, refreshToken = _c[1];
                    if (isAuthenticated) {
                        return [2 /*return*/];
                    }
                    if (onlyCheckLocalToken && !refreshToken) {
                        // Checking for anon user
                        // certain flows we don't want the perf hit of doing an http-only fetch (e.g. graphqlWithAuth)
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, fetchHttpOnlyCookies({
                            oktaConfig: authSdk.authClient.oktaConfig
                        })];
                case 2:
                    _d = _e.sent(), fullRefreshToken = _d.fullRefreshToken, partialRefreshToken = _d.partialRefreshToken;
                    if (!fullRefreshToken && !partialRefreshToken) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, refreshSession({
                            authSdk: authSdk,
                            httpOnlyCookies: { fullRefreshToken: fullRefreshToken, partialRefreshToken: partialRefreshToken },
                            shapeConfig: shapeConfig
                        })];
                case 3: return [2 /*return*/, _e.sent()];
            }
        });
    });
};
// TODO Higher order function to retry calling a rejected async function
var asyncWithRetry = function (asyncFunction, maxRetries) {
    if (maxRetries === void 0) { maxRetries = 3; }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return __awaiter(void 0, void 0, void 0, function () {
            var attempt, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        attempt = 1;
                        _a.label = 1;
                    case 1:
                        if (!(attempt <= maxRetries)) return [3 /*break*/, 6];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, asyncFunction.apply(void 0, __spreadArray([], __read(args), false))];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4:
                        error_1 = _a.sent();
                        if (attempt === maxRetries) {
                            throw new Error("Failed after maxRetries: ".concat(error_1));
                        }
                        debugLog({ message: "Attempt ".concat(attempt, " failed. Retrying...") });
                        attempt++;
                        return [3 /*break*/, 5];
                    case 5: return [3 /*break*/, 1];
                    case 6: throw new Error("Unexpected error during asyncWithRetry"); // Shouldn't reach here, but satisfies TypeScript
                }
            });
        });
    };
};
var handleReqFromCheckout = function (authState) {
    var _a, _b;
    var authorizationLevel = authState.authorizationLevel;
    if (canUseDOM() &&
        ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.pathname) === null || _b === void 0 ? void 0 : _b.includes("/shop/checkout")) &&
        authorizationLevel === "partial") {
        removeOIDCCookie();
        removeRefreshTokenCookie();
        localStorage === null || localStorage === void 0 ? void 0 : localStorage.removeItem("okta-token-storage");
        setAnalyticsAuthState(readAnalyticsAuthState(authState));
    }
};
var graphqlWithAuth = function (_a) {
    var graphParams = _a.graphParams, _b = _a.graphHandler, graphHandler = _b === void 0 ? phoenixClient : _b, oktaConfig = _a.oktaConfig, shapeConfig = _a.shapeConfig;
    return __awaiter(void 0, void 0, void 0, function () {
        var authSdk, authState, error_2;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    // don't bother checking for auth if SSR as auth session refresh only occurs clientside
                    if (!canUseDOM() || process.env.JEST_WORKER_ID !== undefined) {
                        return [2 /*return*/, graphHandler(graphParams)];
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 4, , 5]);
                    authSdk = getAuthSdk({ oktaConfig: oktaConfig, env: "beta" });
                    return [4 /*yield*/, authSdk.authClient.getAuthState()];
                case 2:
                    authState = _c.sent();
                    handleReqFromCheckout(authState);
                    return [4 /*yield*/, checkAndRefreshSession({
                            oktaConfig: oktaConfig,
                            onlyCheckLocalToken: true,
                            shapeConfig: shapeConfig
                        })];
                case 3:
                    _c.sent();
                    return [3 /*break*/, 5];
                case 4:
                    error_2 = _c.sent();
                    logger.error(new Error("Error refreshing session: ".concat(error_2)), {
                        tags: {
                            componentName: "graphqlWithAuth",
                            featureName: "graphqlWithAuth",
                            functionName: "graphqlWithAuth"
                        }
                    });
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/, graphHandler(graphParams)];
            }
        });
    });
};
export { checkAndRefreshSession, graphqlWithAuth, refreshSession };
